import { render } from "./suggestedPartsModal.vue?vue&type=template&id=5dc1fd32&ts=true"
import script from "./suggestedPartsModal.ts?vue&type=script&lang=ts"
export * from "./suggestedPartsModal.ts?vue&type=script&lang=ts"

import "./suggestedPartsModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__